import { css } from '@linaria/core'
import { styled } from '@linaria/react'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { PhotoSize } from 'components/designSystem/shared/photoSize'
import { zIndex } from 'components/designSystem/zIndex'

export const commonCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 52px;
  padding: 10px;
  margin: -10px;
  position: relative;
  cursor: pointer;
  box-sizing: content-box;
  border: 0;
  color: var(--accent-primary-default);
  transition: background-image 0.01s ease, color 0.3s ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--accent-primary-hover);
    }

    &:active {
      color: var(--accent-primary-press);
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    color: var(--static-white);
  }
`
/** Пока так, так как для mobile используется inline стиль
 * useScroll не имеет dependency,
 * чтобы обновится в случае если пришли новые значения.
 */
export const activeCss = css`
  color: var(--accent-secondary-press) !important;

  &:hover,
  &:active {
    color: var(--accent-secondary-press) !important;
  }
`

export const ParentCommon = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.default};
  padding: var(--spacing-24px);
  width: 100%;
  direction: ltr;
  pointer-events: none;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    padding: var(--spacing-12px);
  }

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    width: ${PhotoSize.tablet}px;
  }

  @media screen and (min-width: ${breakpoints.middleDesktop}px) {
    width: ${PhotoSize.middleDesktop}px;
  }

  @media screen and (min-width: ${breakpoints.largeDesktop}px) {
    width: ${PhotoSize.largeDesktop}px;
  }

  & > * {
    pointer-events: all;
  }
`
